import axios from 'axios';
import { apiURL } from '@/config';

export async function addAddress(data) {
    delete data.id;
    return await axios.post(`${apiURL}address-book/`, data, {
        responseType: 'json',
    })
}

export async function fetchAddress() {
    return await axios.get(`${apiURL}address-book/`, {
        responseType: 'json',
    })
}

export async function deleteAddress(id) {
    return await axios.delete(`${apiURL}address-book/${id}`, {
        responseType: 'json',
    })
}

export async function updateAddress(data) {
    delete data.body.id;
    return await axios.put(`${apiURL}address-book/${data.id}`, data.body, {
        responseType: 'json',
    })
}